/**
 * SOS module route manifest.
 *
 * Each route is mounted under the shell's main-layout when this module is active
 * (selected by APP_CODE). The shell never knows about SOS pages beyond this file.
 */
export default {
  code: 'sos',
  routes: [
    {
      // Profil détaillé de l'utilisateur connecté (clic sur l'avatar du tiroir,
      // cf. NavigationService.goToPersonalProfil) : statique, donc accessible
      // sans droit sur le menu « Utilisateurs » du produit.
      // Page « Mon profil » candidat (lit l'utilisateur connecté) : /sosUser/detail est réservé ROLE_ADMIN.
      path: '/sos-my-profile/:userId?',
      name: 'sos-my-profile',
      component: () => import('@sos-pages/sosPersonal.vue'),
      meta: { appCode: 'sos', myProfile: true, appCodes: ['sos', 'skilloscope'] }
    },
    {
      path: '/portal',
      name: 'sos-portal',
      component: () => import('@sos-pages/portal/sosPortal.vue'),
      meta: { appCode: 'sos', title: 'Sos Academy' }
    },
    {
      path: '/assessment',
      name: 'sos-assessment',
      component: () => import('@sos-pages/sosAssessment.vue'),
      meta: { appCode: 'sos', title: 'Évaluation' }
    },
    {
      path: '/candidate-auth',
      name: 'sos-candidate-auth',
      component: () => import('@sos-pages/sosCandidateAuth.vue'),
      meta: { appCode: 'sos', title: 'Accès Skilloscope', public: true }
    },
    {
      path: '/options',
      name: 'sos-test-selection',
      component: () => import('@sos-pages/sosTestSelection.vue'),
      meta: { appCode: 'sos', title: 'Choisir une évaluation' }
    },
    // Choix de l'approche (haut niveau) : catalogue métier vs personnalisé IA.
    {
      path: '/business',
      name: 'sos-test-technical',
      component: () => import('@sos-pages/sosTestCategory.vue'),
      props: { type: 'QUIZ_TECHNICAL' },
      meta: { appCode: 'sos', title: 'Tests techniques' }
    },
    {
      path: '/psycho',
      name: 'sos-test-psycho',
      component: () => import('@sos-pages/sosTestCategory.vue'),
      props: { type: 'QUIZ_PSYCHOLOGICAL' },
      meta: { appCode: 'sos', title: 'Tests psychologiques' }
    },
    // Catalogue à proprement parler (grille de tests) — sous-route du choix.
    {
      path: '/business/catalog',
      name: 'sos-test-technical-catalog',
      component: () => import('@sos-pages/sosTestCatalog.vue'),
      props: { type: 'QUIZ_TECHNICAL' },
      meta: { appCode: 'sos', title: 'Catalogue · Tests techniques' }
    },
    {
      path: '/psycho/catalog',
      name: 'sos-test-psycho-catalog',
      component: () => import('@sos-pages/sosTestCatalog.vue'),
      props: { type: 'QUIZ_PSYCHOLOGICAL' },
      meta: { appCode: 'sos', title: 'Catalogue · Tests psychologiques' }
    },
    {
      path: '/certificate/:uuid',
      name: 'sos-certificate-public',
      component: () => import('@sos-pages/sosCertificatePublic.vue'),
      meta: { appCode: 'sos', title: 'Certificat Skilloscope', public: true }
    },
    {
      // Consultation publique d'une shortlist par le client (token = laissez-passer).
      path: '/shortlist/:token',
      name: 'sos-shortlist-public',
      component: () => import('@sos-pages/sosShortlistPublic.vue'),
      meta: { appCode: 'sos', title: 'Shortlist candidats', public: true }
    },
    {
      path: '/payment-success',
      name: 'payment-success',
      component: () => import('@core/pages/payment/paymentSuccess.vue'),
      meta: { appCode: 'sos', title: 'Paiement confirmé' }
    },
    {
      path: '/payment-cancel',
      name: 'payment-cancel',
      component: () => import('@core/pages/payment/paymentCancel.vue'),
      meta: { appCode: 'sos', title: 'Paiement annulé' }
    },
    {
      path: '/assessment/:quizId',
      name: 'sos-assessment-by-id',
      component: () => import('@sos-pages/sosAssessment.vue'),
      meta: { appCode: 'sos', title: 'Évaluation' }
    },
    {
      // Atterrissage du candidat invité (lien « un clic ») : liste des évaluations
      // de sa/ses campagne(s) recruteur, lance/reprend chacune.
      path: '/invite-tests',
      name: 'sos-invite-tests',
      component: () => import('@sos-pages/sosInviteTests.vue'),
      meta: { appCode: 'sos', title: 'Mes évaluations' }
    },
    // Backward-compat redirects for renamed routes
    { path: '/sos-portal',      redirect: '/portal' },
    { path: '/test-selection',  redirect: '/options' },
    { path: '/test-technical',  redirect: '/business' },
    { path: '/test-psycho',     redirect: '/psycho' },
  ]
}
